import React, { createContext, useContext, useState, useCallback } from "react";

export const LANGS = [
  { code: "ru", label: "RU", name: "Русский" },
  { code: "cs", label: "CZ", name: "Čeština" },
  { code: "en", label: "EN", name: "English" },
];

const translations = {
  ru: {
    brand: "Transfer24",
    nav: { services: "Услуги", calculator: "Калькулятор", routes: "Цены", fleet: "Автопарк", book: "Заказать", contacts: "Контакты" },
    cta: { book: "Заказать трансфер", prices: "Смотреть цены", calc: "Рассчитать стоимость" },
    hero: {
      eyebrow: "Прага · Аэропорты · Европа",
      title: "Трансфер и такси по Праге, Чехии и всей Европе",
      subtitle: "Комфортные премиум-автомобили, фиксированная цена, водители 24/7. Встреча в аэропорту с табличкой, детские кресла и Wi-Fi.",
      badge1: "Работаем 24/7",
      badge2: "Фиксированная цена",
      badge3: "Встреча в аэропорту",
      badge4: "RU · CZ · EN",
      quickTitle: "Быстрый заказ",
      quickNote: "Заявка сразу поступает нашему диспетчеру",
    },
    benefits: {
      title: "Почему выбирают нас",
      subtitle: "Спокойный, надёжный трансфер — от первой минуты до места назначения",
      items: [
        { t: "Круглосуточно", d: "Подача в любое время дня и ночи, включая ранние рейсы" },
        { t: "Фиксированная цена", d: "Стоимость известна заранее — без сюрпризов и счётчика" },
        { t: "Встреча с табличкой", d: "Водитель встретит в зале прилёта с вашим именем" },
        { t: "Отслеживание рейса", d: "Следим за рейсом — подача с учётом задержек" },
        { t: "Детские кресла", d: "Бесплатно по запросу, любого возраста" },
        { t: "Русский и English", d: "Русско- и англоговорящие водители" },
      ],
    },
    services: {
      title: "Направления трансферов",
      subtitle: "Три формата — под любую поездку",
      city: { name: "По городам", desc: "Трансферы между городами Чехии: Прага, Брно, Карловы Вары, Чески-Крумлов, Пльзень и другие. Комфорт и точность в пути.", cta: "Заказать по городу" },
      airport: { name: "Аэропорты", desc: "Встреча и трансфер в аэропорты Праги (PRG), Вены, Мюнхена, Дрездена. Встреча с табличкой, помощь с багажом, контроль рейса.", cta: "Трансфер в аэропорт" },
      long: { name: "Дальние поездки", desc: "Междугородние и международные поездки по Европе. Приватно, по вашему графику, с остановками. Вена, Дрезден, Мюнхен, Берлин.", cta: "Дальняя поездка" },
    },
    calc: {
      eyebrow: "Дальние поездки · 25 Kč / км",
      title: "Калькулятор стоимости",
      subtitle: "Укажите точку А и точку Б — рассчитаем расстояние и цену автоматически",
      from: "Откуда (точка А)",
      to: "Куда (точка Б)",
      fromPh: "Например: Praha, Václavské náměstí",
      toPh: "Например: Wien Flughafen",
      calcBtn: "Рассчитать",
      calculating: "Считаем маршрут…",
      searching: "Поиск адреса…",
      distance: "Расстояние",
      rate: "Тариф",
      price: "Ориентировочная цена",
      perkm: "Kč / км",
      selectHint: "Выберите адрес из подсказок",
      noResult: "Ничего не найдено",
      error: "Не удалось рассчитать маршрут. Уточните адреса.",
      bookThis: "Заказать эту поездку",
      note: "Дорожное расстояние. Точная цена подтверждается перед подачей.",
      ldFee: "надбавка за дальнюю поездку (от 130 км)",
      pickup: "подача автомобиля",
      base: "Поездка",
      wasPrice: "Было",
    },
    routes: {
      title: "Популярные маршруты и цены",
      subtitle: "Фиксированные цены на частые направления",
      all: "Все", city: "Города", airport: "Аэропорты", long: "Дальние",
      col: { route: "Маршрут", distance: "Расстояние", time: "В пути", price: "Цена от", action: "" },
      from: "от", book: "Заказать", popular: "Хит",
    },
    fleet: {
      title: "Наш автопарк",
      subtitle: "Премиум-седан Audi A6 Avant в наличии",
      pax: "пассажиров", lug: "мест багажа", select: "Выбрать авто",
      features: {
        premium_electric: "Премиум электро", wifi: "Wi-Fi", child_seat: "Детское кресло",
        silent_ride: "Тихий ход", business_class: "Бизнес-класс", leather: "Кожаный салон",
      },
    },
    form: {
      title: "Оформить заявку",
      subtitle: "Заполните форму — диспетчер свяжется и подтвердит цену",
      name: "Имя", phone: "Телефон", from: "Откуда", to: "Куда",
      date: "Дата", time: "Время", passengers: "Пассажиры", luggage: "Багаж", comment: "Комментарий",
      namePh: "Ваше имя", phonePh: "+420 …", fromPh: "Адрес подачи", toPh: "Адрес назначения",
      commentPh: "Рейс, детское кресло, остановки…", pickDate: "Выберите дату",
      submit: "Отправить заявку", sending: "Отправка…",
      classSel: "Класс авто", catSel: "Тип поездки",
      cats: { city: "По городу", airport: "Аэропорт", long_distance: "Дальняя", other: "Другое" },
      lug: { none: "Без багажа", small: "1–2 места", medium: "3–4 места", large: "5+ мест" },
      success: "Заявка отправлена! Мы свяжемся с вами в ближайшее время.",
      successTelegram: "Заявка получена диспетчером в Telegram.",
      fail: "Не удалось отправить. Попробуйте ещё раз или позвоните нам.",
      required: "Заполните обязательные поля (имя, телефон, откуда, куда).",
    },
    stats: [
      { v: "24/7", l: "Поддержка и подача" },
      { v: "25 Kč", l: "за км · дальние" },
      { v: "A6", l: "Audi Avant · 2021" },
      { v: "RU·CZ·EN", l: "языки" },
    ],
    reassure: {
      title: "Что будет дальше",
      r1: "Ответим в течение 5 минут",
      r2: "Подтвердим фиксированную цену",
      r3: "Пришлём авто и данные водителя",
      response: "Обычно отвечаем за ~5 минут",
      privacy: "Ваши данные уходят напрямую диспетчеру и нигде не публикуются.",
    },
    seo: {
      title: "Transfer24 — трансфер и такси Прага, аэропорт, межгород по Европе",
      description: "Transfer24 — премиум трансфер и такси в Праге: аэропорт от 850 Kč, города Чехии и дальние поездки по Европе (25 Kč/км). Фиксированные цены, водители 24/7, RU/CZ/EN. Заказ онлайн.",
    },
    footer: {
      tagline: "Премиум трансфер по Праге, Чехии и Европе. Фиксированные цены, водители 24/7.",
      contacts: "Контакты", follow: "Связь", legal: "Информация",
      phone: "Телефон", email: "E-mail", available: "Доступны 24/7",
      rights: "Все права защищены.",
    },
    common: { close: "Закрыть", menu: "Меню" },
  },

  cs: {
    brand: "Transfer24",
    nav: { services: "Služby", calculator: "Kalkulačka", routes: "Ceny", fleet: "Vozový park", book: "Objednat", contacts: "Kontakt" },
    cta: { book: "Objednat transfer", prices: "Zobrazit ceny", calc: "Spočítat cenu" },
    hero: {
      eyebrow: "Praha · Letiště · Evropa",
      title: "Transfer a taxi po Praze, Česku a celé Evropě",
      subtitle: "Komfortní prémiová auta, pevná cena, řidiči 24/7. Vyzvednutí na letišti s cedulí, dětské sedačky a Wi-Fi.",
      badge1: "24/7 provoz",
      badge2: "Pevná cena",
      badge3: "Vyzvednutí na letišti",
      badge4: "RU · CZ · EN",
      quickTitle: "Rychlá objednávka",
      quickNote: "Poptávka jde přímo našemu dispečerovi",
    },
    benefits: {
      title: "Proč my",
      subtitle: "Klidný a spolehlivý transfer od první minuty až do cíle",
      items: [
        { t: "Nonstop", d: "Přistavení kdykoli ve dne i v noci, i rané lety" },
        { t: "Pevná cena", d: "Cenu znáte předem — žádná překvapení ani taxametr" },
        { t: "Vyzvednutí s cedulí", d: "Řidič vás počká v příletové hale se jménem" },
        { t: "Sledování letu", d: "Hlídáme let — přistavení podle zpoždění" },
        { t: "Dětské sedačky", d: "Zdarma na vyžádání, pro každý věk" },
        { t: "RU a English", d: "Rusky i anglicky mluvící řidiči" },
      ],
    },
    services: {
      title: "Druhy transferů",
      subtitle: "Tři formáty pro každou cestu",
      city: { name: "Mezi městy", desc: "Transfery mezi českými městy: Praha, Brno, Karlovy Vary, Český Krumlov, Plzeň a další. Pohodlí a přesnost na cestě.", cta: "Objednat po městě" },
      airport: { name: "Letiště", desc: "Vyzvednutí a transfer na letiště Praha (PRG), Vídeň, Mnichov, Drážďany. Cedule se jménem, pomoc se zavazadly, sledování letu.", cta: "Transfer na letiště" },
      long: { name: "Dálkové jízdy", desc: "Meziměstské a mezinárodní cesty po Evropě. Soukromě, podle vašeho programu, se zastávkami. Vídeň, Drážďany, Mnichov, Berlín.", cta: "Dálková jízda" },
    },
    calc: {
      eyebrow: "Dálkové jízdy · 25 Kč / km",
      title: "Kalkulačka ceny",
      subtitle: "Zadejte bod A a bod B — vzdálenost i cenu spočítáme automaticky",
      from: "Odkud (bod A)",
      to: "Kam (bod B)",
      fromPh: "Např.: Praha, Václavské náměstí",
      toPh: "Např.: Wien Flughafen",
      calcBtn: "Spočítat",
      calculating: "Počítáme trasu…",
      searching: "Hledám adresu…",
      distance: "Vzdálenost",
      rate: "Sazba",
      price: "Orientační cena",
      perkm: "Kč / km",
      selectHint: "Vyberte adresu z nabídky",
      noResult: "Nic nenalezeno",
      error: "Trasu se nepodařilo spočítat. Upřesněte adresy.",
      bookThis: "Objednat tuto cestu",
      note: "Silniční vzdálenost. Přesná cena se potvrdí před přistavením.",
      ldFee: "příplatek za dálkovou jízdu (od 130 km)",
      pickup: "přistavení vozu",
      base: "Jízda",
      wasPrice: "Původně",
    },
    routes: {
      title: "Oblíbené trasy a ceny",
      subtitle: "Pevné ceny na časté směry",
      all: "Vše", city: "Města", airport: "Letiště", long: "Dálkové",
      col: { route: "Trasa", distance: "Vzdálenost", time: "Doba", price: "Cena od", action: "" },
      from: "od", book: "Objednat", popular: "TOP",
    },
    fleet: {
      title: "Vozový park",
      subtitle: "Prémiový vůz Audi A6 Avant k dispozici",
      pax: "cestujících", lug: "zavazadel", select: "Vybrat vůz",
      features: {
        premium_electric: "Prémiové elektro", wifi: "Wi-Fi", child_seat: "Dětská sedačka",
        silent_ride: "Tichá jízda", business_class: "Business class", leather: "Kožený interiér",
      },
    },
    form: {
      title: "Vytvořit poptávku",
      subtitle: "Vyplňte formulář — dispečer se ozve a potvrdí cenu",
      name: "Jméno", phone: "Telefon", from: "Odkud", to: "Kam",
      date: "Datum", time: "Čas", passengers: "Cestující", luggage: "Zavazadla", comment: "Poznámka",
      namePh: "Vaše jméno", phonePh: "+420 …", fromPh: "Adresa vyzvednutí", toPh: "Cílová adresa",
      commentPh: "Let, dětská sedačka, zastávky…", pickDate: "Vyberte datum",
      submit: "Odeslat poptávku", sending: "Odesílám…",
      classSel: "Třída vozu", catSel: "Druh cesty",
      cats: { city: "Po městě", airport: "Letiště", long_distance: "Dálková", other: "Jiné" },
      lug: { none: "Bez zavazadel", small: "1–2 kusy", medium: "3–4 kusy", large: "5+ kusů" },
      success: "Poptávka odeslána! Brzy se vám ozveme.",
      successTelegram: "Poptávku přijal dispečer na Telegramu.",
      fail: "Odeslání se nezdařilo. Zkuste to znovu nebo zavolejte.",
      required: "Vyplňte povinná pole (jméno, telefon, odkud, kam).",
    },
    stats: [
      { v: "24/7", l: "Podpora a přistavení" },
      { v: "25 Kč", l: "za km · dálkové" },
      { v: "A6", l: "Audi Avant · 2021" },
      { v: "RU·CZ·EN", l: "jazyky" },
    ],
    reassure: {
      title: "Co bude dál",
      r1: "Odpovíme do 5 minut",
      r2: "Potvrdíme pevnou cenu",
      r3: "Pošleme vůz a údaje řidiče",
      response: "Obvykle odpovídáme do ~5 minut",
      privacy: "Vaše údaje jdou přímo dispečerovi a nikde se nezveřejňují.",
    },
    seo: {
      title: "Transfer24 — transfer a taxi Praha, letiště, dálkové jízdy po Evropě",
      description: "Transfer24 — prémiový transfer a taxi v Praze: letiště od 850 Kč, česká města a dálkové jízdy po Evropě (25 Kč/km). Pevné ceny, řidiči 24/7, RU/CZ/EN. Objednávka online.",
    },
    footer: {
      tagline: "Prémiový transfer po Praze, Česku a Evropě. Pevné ceny, řidiči 24/7.",
      contacts: "Kontakt", follow: "Spojení", legal: "Informace",
      phone: "Telefon", email: "E-mail", available: "K dispozici 24/7",
      rights: "Všechna práva vyhrazena.",
    },
    common: { close: "Zavřít", menu: "Menu" },
  },

  en: {
    brand: "Transfer24",
    nav: { services: "Services", calculator: "Calculator", routes: "Prices", fleet: "Fleet", book: "Book", contacts: "Contacts" },
    cta: { book: "Book a transfer", prices: "View prices", calc: "Calculate price" },
    hero: {
      eyebrow: "Prague · Airports · Europe",
      title: "Transfers & taxi across Prague, Czechia and Europe",
      subtitle: "Comfortable premium cars, fixed price, drivers 24/7. Airport meet & greet, child seats and Wi-Fi.",
      badge1: "24/7 service",
      badge2: "Fixed price",
      badge3: "Airport meet & greet",
      badge4: "RU · CZ · EN",
      quickTitle: "Quick booking",
      quickNote: "Your request goes straight to our dispatcher",
    },
    benefits: {
      title: "Why choose us",
      subtitle: "A calm, reliable transfer from the very first minute to your destination",
      items: [
        { t: "Around the clock", d: "Pickup any time, day or night, including early flights" },
        { t: "Fixed price", d: "Price known upfront — no surprises, no meter" },
        { t: "Meet & greet", d: "Driver meets you in arrivals with your name sign" },
        { t: "Flight tracking", d: "We track your flight and adjust the pickup" },
        { t: "Child seats", d: "Free on request, for any age" },
        { t: "RU & English", d: "Russian and English speaking drivers" },
      ],
    },
    services: {
      title: "Transfer directions",
      subtitle: "Three formats for any trip",
      city: { name: "Between cities", desc: "Transfers between Czech cities: Prague, Brno, Karlovy Vary, Český Krumlov, Plzeň and more. Comfort and punctuality on the road.", cta: "Book city transfer" },
      airport: { name: "Airports", desc: "Meet & greet and transfers to Prague (PRG), Vienna, Munich, Dresden airports. Name sign, luggage help, flight tracking.", cta: "Airport transfer" },
      long: { name: "Long-distance", desc: "Intercity and international trips across Europe. Private, on your schedule, with stops. Vienna, Dresden, Munich, Berlin.", cta: "Long-distance trip" },
    },
    calc: {
      eyebrow: "Long-distance · 25 CZK / km",
      title: "Price calculator",
      subtitle: "Enter point A and point B — we compute distance and price automatically",
      from: "From (point A)",
      to: "To (point B)",
      fromPh: "e.g. Prague, Wenceslas Square",
      toPh: "e.g. Vienna Airport",
      calcBtn: "Calculate",
      calculating: "Calculating route…",
      searching: "Searching address…",
      distance: "Distance",
      rate: "Rate",
      price: "Estimated price",
      perkm: "CZK / km",
      selectHint: "Pick an address from suggestions",
      noResult: "Nothing found",
      error: "Could not calculate the route. Please refine the addresses.",
      bookThis: "Book this trip",
      note: "Road distance. Exact price confirmed before pickup.",
      ldFee: "long-distance surcharge (over 130 km)",
      pickup: "pickup fee",
      base: "Ride",
      wasPrice: "Was",
    },
    routes: {
      title: "Popular routes & prices",
      subtitle: "Fixed prices for frequent directions",
      all: "All", city: "Cities", airport: "Airports", long: "Long-distance",
      col: { route: "Route", distance: "Distance", time: "Duration", price: "Price from", action: "" },
      from: "from", book: "Book", popular: "Top",
    },
    fleet: {
      title: "Our fleet",
      subtitle: "Premium Audi A6 Avant available",
      pax: "passengers", lug: "luggage", select: "Select car",
      features: {
        premium_electric: "Premium electric", wifi: "Wi-Fi", child_seat: "Child seat",
        silent_ride: "Silent ride", business_class: "Business class", leather: "Leather interior",
      },
    },
    form: {
      title: "Make a request",
      subtitle: "Fill in the form — our dispatcher will contact you and confirm the price",
      name: "Name", phone: "Phone", from: "From", to: "To",
      date: "Date", time: "Time", passengers: "Passengers", luggage: "Luggage", comment: "Comment",
      namePh: "Your name", phonePh: "+420 …", fromPh: "Pickup address", toPh: "Destination address",
      commentPh: "Flight, child seat, stops…", pickDate: "Pick a date",
      submit: "Send request", sending: "Sending…",
      classSel: "Car class", catSel: "Trip type",
      cats: { city: "City", airport: "Airport", long_distance: "Long-distance", other: "Other" },
      lug: { none: "No luggage", small: "1–2 pieces", medium: "3–4 pieces", large: "5+ pieces" },
      success: "Request sent! We'll get back to you shortly.",
      successTelegram: "Request received by the dispatcher on Telegram.",
      fail: "Could not send. Please try again or call us.",
      required: "Please fill required fields (name, phone, from, to).",
    },
    stats: [
      { v: "24/7", l: "Support & pickup" },
      { v: "25 CZK", l: "per km · long-distance" },
      { v: "A6", l: "Audi Avant · 2021" },
      { v: "RU·CZ·EN", l: "languages" },
    ],
    reassure: {
      title: "What happens next",
      r1: "We reply within 5 minutes",
      r2: "We confirm the fixed price",
      r3: "We send the car & driver details",
      response: "We usually reply in ~5 minutes",
      privacy: "Your details go straight to the dispatcher and are never published.",
    },
    seo: {
      title: "Transfer24 — Prague transfer & taxi, airport, long-distance across Europe",
      description: "Transfer24 — premium Prague transfer & taxi: airport from 850 CZK, Czech cities and long-distance trips across Europe (25 CZK/km). Fixed prices, drivers 24/7, RU/CZ/EN. Book online.",
    },
    footer: {
      tagline: "Premium transfers across Prague, Czechia and Europe. Fixed prices, drivers 24/7.",
      contacts: "Contacts", follow: "Connect", legal: "Info",
      phone: "Phone", email: "E-mail", available: "Available 24/7",
      rights: "All rights reserved.",
    },
    common: { close: "Close", menu: "Menu" },
  },
};

const I18nContext = createContext(null);

function get(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

function getInitialLang() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get("lang") || "").toLowerCase();
    if (["ru", "cs", "en"].includes(q)) return q;
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("cs")) return "cs";
    if (nav.startsWith("en")) return "en";
  } catch (e) {}
  return "ru";
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(getInitialLang);
  const t = useCallback(
    (key) => {
      const val = get(translations[lang], key);
      if (val === undefined) {
        const fallback = get(translations.en, key);
        return fallback === undefined ? key : fallback;
      }
      return val;
    },
    [lang]
  );
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
